import { IonContent, IonInput, IonPage, IonText, IonTextarea, IonSpinner, IonIcon, IonButton } from "@ionic/react"
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import moment from "moment";
import Select from 'react-select';
import swal from 'sweetalert'
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const Compoff: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData] = useState([]);
    const [modal, setmodal] = useState(false)
    const [updatecompoff, setUpdatecompoff] = useState('');
    const [empid] = useState(localStorage.getItem('SignupEmpId'))
    const [bal, setbal] = useState('')
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [compoffstatus, setCompoffstatus] = useState("");
    const [workondate, setworkondate] = useState('');
    const [dateview, setdateview] = useState('')
    const [reasons, setreasons] = useState('');
    const [remark, setremark] = useState('')
    if (Array.isArray(data)) {
        data.forEach((item: any, index: any) => {
            item.serial = index + 1;
        });
    }
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [workdate, setworkdate] = useState("");
    const [reason, setreason] = useState("");
    const [date, setdate] = useState("");
    const [dateup, setdateup] = useState("");
    const [id, setid] = useState("");
    const [leaveType, setLeaveType] = useState("");
    const [status, setStatus] = useState(true);
    const [statusid, setStatusid] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setTodate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [NoOfDays, setNoOfDays] = useState("");
    const [remarks, setRemarks] = useState("");
    const [lopFlag, setLopFlag] = useState(0);
    const [statusFlag, setStatusFlag] = useState(true);
    const [idsof, setidsof] = useState("");
    const [holidaydate, setholidaydate] = useState('');
    const [compoffdate, setcompoffdate] = useState('');
    const [regreason, setregreason] = useState('')
    const [empCode] = useState(localStorage.getItem("empCode"));
    const [statusList, setStatusList]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [Empid, setEmpid] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [empName, setEmpName] = useState('');

    //------------------View-Modal------------------//

    const openmodal = (itm: any) => {
        setModalData(itm);
        console.log("Row Data:", itm);
        setEmpid(itm.employeeId)
        setEmpCode(itm.employeeDetails.employeeCode);
        setEmpName(itm.employeeDetails.name);
        setworkdate(itm.workedOnDate);
        setreason(itm.reason);
        setStatus(itm.status);
        setdateview(itm.compOffDate);
        setremark(itm.remarks)
        setid(itm.id)
        setModalopen(true);
        setUpdatecompoff(itm.compOffStatus.id);
        setCompoffstatus(itm.compOffStatus.status);
        console.log(itm.compOffStatus.status, "compostatus")
    }

    const openmodals = (itm: any) => {
        setmodal(true)
        console.log("id", itm.id)

        setworkondate(itm.workedOnDate)
        setreasons(itm.reason)
        setid(itm.id)

    }
    const closemodals = () => {
        setmodal(false)
        setworkdate('');
        setreason('');
        setdate('')
    }
    const closemodalss = () => {
        setModalopen1(false)
        setholidaydate('');
        setcompoffdate('')
        setregreason('');
    }
    const openmodal1 = () => {
        setModalopen1(true);
    }

    const closemodal = () => {
        setModalopen(false);
        setLeaveType("");
        // setStatus("");
        setFromDate("");
        setTodate("");
        setLeaveReason("");
        setReportingPerson("");
        setNoOfDays("");
        setRemarks("");

    }

    //-----------------------Compoff-Register------------------------//

    const Compoffregister = () => {

        if (!holidaydate) {
            swal("", "Please select a valid workdate.", "error");
            return;
        }
        if (!regreason) {
            swal("", "Please provide a reason.", "error");
            return;
        }
        service.Compoffsave(empid, holidaydate, regreason, statusid, date, status)
            .then((response) => {
                console.log(response);

                if (response.data.status === 200) {
                    setworkondate(response.data.data.workedOnDate)
                    swal("", response.data.message, "success")
                        .then(() => {
                            window.location.reload();
                        });
                } else if (response.data.status === 400) {
                    swal("", response.data.message, 'error');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //-------------------------Compoff-Apply-------------------------//

    const CompoffApply = () => {


        if (!date) {
            swal("", "Please select a valid Compoffdate.", "error");
            return;
        }

        service.CompoffApply(id, empid, workondate, reasons, statusid, date, status)
            .then((response) => {
                console.log(response);
                console.log(id, "id of the comp off")
                if (response.data.status === 200) {


                    swal("", response.data.message, "success")
                        .then(() => {
                            window.location.reload();
                        });
                } else if (response.data.status === 400) {
                    swal("", response.data.message, 'error');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //---------------------------Compoff-Balance Api-----------------------------//

    const Compoffbal = () => {
        service.Compoffbalance(empid)
            .then((response) => {
                // console.log(response);
                console.log(response, "compoff balance")
                if (response.status === 200) {
                    setbal(response.data)
                }
            })
            .catch((error) => {
                console.error(error);

            });
    };

    //----------------------Compoff-Datatable-----------------------//

    const Compofftable = () => {
        service.Compoffgetall(empid)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    setData(response.data.data)
                }
            })
            .catch((error) => {
                console.error(error);

            });
    };

    const Compoffdate = (selectedDate: any) => {
        service.Compoffdatecheck(empid, selectedDate)
            .then((response) => {
                console.log(response, "compoff date");
                if (response.data.status === 200) {

                } else if (response.data.status === 400) {

                    swal("", response.data.message, "info");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // const Compoffdate = () => {
    //     service.Compoffdatecheck(empid, holidaydate)
    //         .then((response) => {
    //             console.log(response, "compoff date");
    //             if (response.status === 200) {
    //                 // Handle the response if status is 200
    //             } else if (response.status === 400) {
    //                 // Show response data message in Swal if status is 400
    //                 swal("", response.data.message, "error");
    //             }
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         });
    // };

    //--------------------UseEffect---------------------//

    useEffect(() => {
        GetStatus();
        Compoffbal();
        Compofftable();
        console.log(status, 'idsss')
    }, []);

    //------------------------Compoff Update Api-----------------------//

    const CompoffUpdate = () => {
        service.Compoffupdate(id, empid, workdate, reason, remark, updatecompoff, dateview, status)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    swal("", response.data.message, "success")
                        .then(() => {
                            window.location.reload();
                        });
                } else if (response.data.status === 400) {
                    swal("", response.data.message, "error");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //--------------------------Compoff-Delete Api-----------------------------//

    const CompoffDelete = () => {
        service.Compoffdelete(id, empid, workdate, reason, date, false)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    swal("", response.data.message, "success")
                        .then(() => {
                            window.location.reload();
                        });
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //--------------------Comp-off Status Api--------------------------//

    const GetStatus = () => {
        service.GetCompoffstatus()
            .then((response) => {
                console.log(response, "reponse for compoff status")
                if (response.data.Status === 200) {
                    for (let i = 0; i < response.data.data.length; i++) {
                        if (response.data.data[i].status === "CompOff Registered") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Regn Approved") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Regn Rejected") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Regn Cancelled") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Leave Applied") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Leave Approved") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Leave Rejected") {
                            setStatusid(response.data.data[i].id)
                        }
                        else if (response.data.data[i].status === "CompOff Leave Cancelled") {
                            setStatusid(response.data.data[i].id)
                        }
                    }
                    setStatusList(response.data.data);

                }
                else {
                    setStatusList([]);
                }
            })
    }
    const getStatusColor = (status: string) => {
        switch (status) {
            case "Approved":
                return "green";
            case "Registered":
                return "orange";
            case "Cancelled":
                return "red";
            case "CompOff Leave Rejected":
                return "red";
            case "CompOff Regn Rejected":
                return "red";
            default:
                return "black";
        }
    };

    //--------------------Comp-off Datatable--------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px"
        },
        {
            name: "Worked On",
            selector: (itm: any) => itm.workedOnDate,
            cell: (itm: any) => moment(itm.workedOnDate).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Status",
            selector: (itm: any) => itm.compOffStatus.status,
            sortable: true,
            width: "320px",
            cell: (itm: any) => (
                <span
                    style={{
                        color: getStatusColor(itm.compOffStatus.status),

                    }}
                >
                    {itm.compOffStatus.status}
                </span>
            ),
        },
        {
            name: "Comp-Off Date",
            selector: (itm: any) => itm.compOffDate,
            width: "180px",
            cell: (itm: any) => (
                <IonText>
                    {itm.compOffDate ? moment(itm.compOffDate).format("DD-MM-YYYY") : "NA"}
                </IonText>
            ),
            sortable: true,
        },


        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        },
        {
            name: "",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", color: "coral", cursor: 'pointer' }}>
                        {itm.compOffStatus.status === "CompOff Regn Approved" ||
                            itm.compOffStatus.status === "CompOff Leave Rejected" ||
                            itm.compOffStatus.status === "CompOff Leave Cancelled" ? (
                            <IonText onClick={() => openmodals(itm)}>
                                Apply Comp-Off Leave
                            </IonText>
                        ) : null}
                    </div>
                </>
            )
        }


    ]

    const datatable = Array.isArray(data)
        ? data.filter((item: any) => JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
        : [];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
                // paddingLeft:"0px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };
    const back = () => {
        history.goBack();
    }

    //---------------------------Search filter----------------------//

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col-sm-12">
                                    <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> CompOff </h3>
                                    <div className="col-auto float-end ml-auto">
                                        <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Register Compoff</a>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="stats-info">
                                        <h6 style={{ fontWeight: "bold" }}>Available CompOff</h6>
                                        <h4 style={{ fontWeight: "bolder" }}>{bal}</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ------------------------View-Compoff------------------------- */}

                <Modal dialogClassName="modal-dialog modal-lg"
                    show={modalopen}>
                    <div className="modal-header">
                        <h5 className="modal-title">View Compoff</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Employee Id/Name </label>
                                <div>
                                    <IonInput
                                        value={empName}
                                        readonly={compoffstatus === 'CompOff Regn Approved'}
                                        style={{ backgroundColor: compoffstatus === 'CompOff Regn Approved' ? '#f0f0f0' : 'inherit' }}
                                        className="form-control datetimepicker"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label style={{ fontWeight: "bold" }}>Holiday Work Date </label>
                            <div>
                                {/* <IonInput
                                    value={workdate}
                                    disabled={compoffstatus === 'CompOff Leave Cancelled' || compoffstatus === 'CompOff Leave Rejected' || compoffstatus === 'CompOff Leave Applied'}
                                    style={{ backgroundColor: compoffstatus === 'CompOff Leave Cancelled' || compoffstatus === 'CompOff Leave Rejected' || compoffstatus === 'CompOff Leave Applied' ? '#f0f0f0' : 'inherit' }}
                                    onIonChange={(e: any, selectedDate: any) => { setworkdate(e.target.value), Compoffdate(selectedDate); }}
                                    className="form-control datetimepicker"
                                    type="date"
                                /> */}
                                <IonInput
                                    value={workdate}
                                    disabled={compoffstatus === 'CompOff Leave Cancelled' || compoffstatus === 'CompOff Leave Rejected' || compoffstatus === 'CompOff Leave Applied'}
                                    style={{ backgroundColor: compoffstatus === 'CompOff Leave Cancelled' || compoffstatus === 'CompOff Leave Rejected' || compoffstatus === 'CompOff Leave Applied' ? '#f0f0f0' : 'inherit' }}
                                    onIonChange={(e: any) => {
                                        setworkdate(e.target.value);
                                        Compoffdate(e.target.value);
                                    }}
                                    className="form-control datetimepicker"
                                    type="date"
                                />


                            </div>
                        </div>
                        {compoffstatus !== 'CompOff Regn Approved' && compoffstatus !== 'CompOff Registered' && compoffstatus !== 'CompOff Regn Cancelled' && compoffstatus !== 'CompOff Regn Rejected' && (
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Compoff-Date </label>
                                <div>
                                    <IonInput
                                        value={dateview}
                                        //readonly={compoffstatus === 'CompOff Leave Approved'}
                                        //  style={{ backgroundColor: compoffstatus === 'CompOff Leave Approved' ? '#f0f0f0' : 'inherit' }}
                                        onIonChange={(e: any) => setdateview(e.target.value)}
                                        className="form-control datetimepicker"
                                        type="date"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="form-group">
                            <label style={{ fontWeight: "bold" }}>Reason </label>
                            <div>
                                <IonInput
                                    value={reason}
                                    //  readonly={compoffstatus === 'CompOff Regn Approved'}

                                    //style={{ backgroundColor: compoffstatus === 'CompOff Regn Approved' ? '#f0f0f0' : 'inherit' }}
                                    onIonChange={(e: any) => setreason(e.target.value)}
                                    className="form-control datetimepicker"
                                />
                            </div>
                        </div>
                        {(compoffstatus === 'CompOff Regn Rejected' || compoffstatus === 'CompOff Leave Rejected') && (
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Remarks<span className="text-danger">*</span></label>
                                <textarea value={remark} onChange={(e: any) => setremark(e.target.value)} className="form-control" />
                            </div>
                        )}


                        {(compoffstatus === "Pending") && (
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Compoff-Date </label>
                                <div>
                                    <IonInput
                                        value={dateview}
                                        // readonly={compoffstatus === 'CompOff Regn Approved'}
                                        // style={{ backgroundColor: compoffstatus === 'CompOff Regn Approved' ? '#f0f0f0' : 'inherit' }}
                                        onIonChange={(e: any) => setdateview(e.target.value)}
                                        className="form-control datetimepicker"
                                        type='date'
                                    />
                                </div>
                            </div>
                        )}

                        <div className="submit-section">
                            {compoffstatus === 'CompOff Regn Approved' || compoffstatus === 'CompOff Leave Rejected' || compoffstatus === 'CompOff Regn Rejected' || compoffstatus === 'CompOff Regn Cancelled' || compoffstatus === 'CompOff Leave Approved' ? (
                                <button onClick={closemodal} type="button" className="btn btn-primary submit-btn">
                                    Exit
                                </button>
                            ) : (
                                <>
                                    <div className="button-row" style={{
                                        gap: "10px",
                                        display: "flex",
                                        justifyContent: "space-evenly",

                                    }}>
                                        <button onClick={CompoffUpdate} type="button" className="btn btn-primary submit-btn">
                                            Update
                                        </button>
                                        {compoffstatus !== 'CompOff Leave Applied' && compoffstatus !== 'CompOff Leave Rejected' && (
                                            <button onClick={CompoffDelete} type="button" className="btn btn-primary submit-btn">
                                                Delete CompOff-Request
                                            </button>
                                        )}
                                        {(compoffstatus === 'CompOff Leave Applied' || compoffstatus === 'CompOff Leave Rejected') && (
                                            <button onClick={CompoffDelete} type="button" className="btn btn-primary submit-btn">
                                                Cancel Compoff-Leave
                                            </button>
                                        )}


                                        <button onClick={closemodal} type="button" className="btn btn-primary submit-btn">
                                            Exit
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>


                </Modal>

                {/* ------------------------Register-Compoff--------------------- */}

                <Modal dialogClassName="modal-dialog modal-lg" show={modalopen1}>
                    <div className="modal-header">
                        <h5 className="modal-title">Register Compensatory Off</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodalss()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Employee Code/Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={empCode} readonly className="form-control datetimepicker" />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Holiday Work Date <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput
                                            value={holidaydate}
                                            onIonChange={(e: any) => {
                                                const selectedDate = e.detail.value; // Get the selected date
                                                setholidaydate(selectedDate); // Update the state with selected date

                                                // Call API only if a valid date is selected
                                                if (selectedDate) {
                                                    Compoffdate(selectedDate); // Pass the selected date to Compoffdate
                                                }
                                            }}
                                            type='date'
                                            className="form-control datetimepicker"
                                            max={new Date().toISOString().split('T')[0]}
                                        />



                                    </div>
                                </div>



                                <div className=" form-group">
                                    <label style={{ fontWeight: "bold" }}>Reason<span className="text-danger">*</span></label>
                                    <textarea value={regreason} onChange={(e) => setregreason(e.target.value)} className="form-control" />
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn btn-primary submit-btn" onClick={Compoffregister}>Submit for Approval</button>
                                </div>
                            </div>
                        </form>
                        {isLoading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div>
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                    </div>
                </Modal>

                {/* ------------------------Apply-Compoff---------------------------*/}

                <Modal dialogClassName="modal-dialog modal-lg" show={modal}>
                    <div className="modal-header">
                        <h5 className="modal-title">Apply Compensatory Off</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodals()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Employee Id/Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={empCode} readonly className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Holiday Work Date <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={workondate} readonly type='date' className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Compoff Date <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={date} onIonChange={(e: any) => setdate(e.target.value)} type='date' className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className=" form-group">
                                    <label style={{ fontWeight: "bold" }}>Reason<span className="text-danger">*</span></label>
                                    <textarea value={reasons} readOnly onChange={(e: any) => setreasons(e.target.value)} className="form-control" />
                                </div>

                                <div className="btn-section">
                                    <div style={{ marginTop: "10px" }}>
                                        <button onClick={CompoffApply} type="button" className="btn btn-primary submit-btn" >
                                            Submit for Approval
                                        </button>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        <button onClick={closemodals} type="button" className="btn btn-secondary submit-btn" >
                                            Exit
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </form>
                        {isLoading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}>
                                <div>
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default Compoff;